import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_AVAILABLE_SUBSCRIPTIONS_SAGA } from "../sagaTypes";
import { loaderAction, setAvailableSubscriptionsFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_available_subscriptions`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetAvailableSubscriptions(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('user', args.data.user);
        formData.append('booking_id', args.data.booking_id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            yield put(setAvailableSubscriptionsFormAction(response.available_subscriptions_form));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetAvailableSubscriptions() {
    yield takeLatest(GET_AVAILABLE_SUBSCRIPTIONS_SAGA, workerGetAvailableSubscriptions);
}